import { FieldOptions } from '../index';
import { EasyField } from '../baseClasses/easyField';

export class EasyDatePickerField extends EasyField {
    controlType = 'date-picker';

    constructor(options: FieldOptions<Date> = {}) {
        super(options);
        options.controlType = this.controlType;
    }
}
